import React, { useState } from "react";
import { useAuthStore } from "../store/store";

const SignupPage = () => {
  const { registration } = useAuthStore();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    country: "",
    city: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match!");
      return;
    }

    try {
      const response = await registration({
        firstName: formData.firstName,
        lastName: formData.lastName,
        country: formData.country,
        city: formData.city,
        accountType: "user",
        email: formData.email,
        password: formData.password,
      });

      const data = await response?.data;

      if (response?.err)
        throw new Error(response?.err || "Registration failed");

      window.location.href = "/login";
      setSuccess("Registration successful!");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="min-h-screen flex my-10 items-center justify-center bg-white p-4">
      <div className="w-full max-w-md bg-white rounded-3xl p-10 shadow-lg">
        <h2 className="text-4xl font-bold text-center mb-8 text-gray-800">
          Create Your Account
        </h2>
        {error && <p className="text-red-500 text-center">{error}</p>}
        {success && <p className="text-green-500 text-center">{success}</p>}
        <form className="space-y-6" onSubmit={handleSubmit}>
          {[
            "firstName",
            "lastName",
            "country",
            "city",
            "email",
            "password",
            "confirmPassword",
          ].map((field, idx) => (
            <input
              key={idx}
              type={
                field.includes("password")
                  ? "password"
                  : field === "email"
                  ? "email"
                  : "text"
              }
              name={field}
              placeholder={field.replace(/([A-Z])/g, " $1").trim()}
              className="w-full px-5 py-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
              value={formData[field]}
              onChange={handleChange}
            />
          ))}
          <button
            type="submit"
            className="w-full bg-indigo-500 hover:bg-indigo-600 text-white py-3 rounded-full shadow-lg transition duration-300"
          >
            Sign Up
          </button>
        </form>
        <p className="text-center text-gray-600 mt-6">
          Already have an account?
          <span
            onClick={() => (window.location.href = "/login")}
            className="text-indigo-500 cursor-pointer ml-1 hover:underline"
          >
            Login
          </span>
        </p>
      </div>
    </div>
  );
};

export default SignupPage;
